export { getWindow } from './src/browserEnvironment'

export {
  getClientDatadogRumSdkAppID,
  getClientDatadogBrowserLogsClientToken,
  getClientDatadogRumSdkClientToken,
} from './src/configFromWindow'
